import { render, staticRenderFns } from "./application-activities-tab.vue?vue&type=template&id=27780675"
import script from "./application-activities-tab.vue?vue&type=script&lang=js"
export * from "./application-activities-tab.vue?vue&type=script&lang=js"
import style0 from "./application-activities-tab.vue?vue&type=style&index=0&id=27780675&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports